import React, {forwardRef} from 'react';
import MessageList from './MessageList';
import InputBox from './InputBox';
import WelcomePanel from './WelcomePanel';
import { useChat } from '../../contexts/ChatContext';

const ChatBox = forwardRef((props, ref)=> {
  const {state} = useChat();
  const {/** @type {ChatMessage[]} */ messages} = state;

  return (
    <div ref={ref} className="flex flex-col h-screen bg-gradient-to-b from-gray-800 to-black shadow-md rounded-lg">
      {messages.length>0?
      <MessageList /> : 
      <WelcomePanel />}
      
      <InputBox chatBoxRef={ref} />
    </div>
  );
}
);

export default ChatBox;